import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold transition-all duration-300 rounded-lg shadow-lg';
  const variants = {
    primary: 'bg-[#c9a84c] hover:bg-[#d4af5a] text-[#0f1923] hover:shadow-[#c9a84c]/20 hover:-translate-y-1',
    secondary: 'bg-[#faf6f0] text-[#0f1923] hover:bg-white hover:shadow-white/10',
    outline: 'border-2 border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-215">
      {children}
    </motion.button>;
}